import React from "react";
import "./Loader.css";
// import loaderImage from '../../../assets/images/human-resources 1.png';
import loaderImage from "../../../assets/images/headerimg.png";

const Loader = () => {
  return (
    <div className="loader-container">
      <img src={loaderImage} alt="Loading..." className="loader-image" />
    </div>
  );
};

export default Loader;
